import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome, ${u.contact_name || u.email}`);
      const from = location.state?.from?.pathname;
      if (from) navigate(from, { replace: true });
      else if (u.role === "admin") navigate("/admin/leads");
      else navigate("/dashboard");
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="login-page">
      <div className="label-tag">Sign In</div>
      <h1 className="font-heading text-4xl md:text-5xl font-black uppercase mt-2 leading-none text-[#1A365D]">
        Welcome back.
      </h1>
      <p className="mt-2 text-slate-600">Manufacturers, dealers and admins log in here.</p>

      <form onSubmit={submit} className="brutal-card p-8 mt-8 space-y-5">
        <div>
          <label className="label-tag block mb-2">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="ll-input" data-testid="login-email-input"/>
        </div>
        <div>
          <label className="label-tag block mb-2">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="ll-input" data-testid="login-password-input"/>
        </div>
        <button type="submit" className="btn-primary w-full" disabled={loading} data-testid="login-submit-btn">
          {loading ? "Signing in…" : "Sign In"}
        </button>
        <div className="text-sm text-center">
          <Link to="/forgot-password" className="text-slate-600 hover:text-[#C62828] hover:underline" data-testid="forgot-password-link">
            Forgot your password?
          </Link>
        </div>
        <div className="text-sm text-slate-600 text-center">
          New here? <Link to="/register" className="font-bold text-[#C62828] hover:underline" data-testid="login-to-register-link">Create a manufacturer account</Link>
        </div>
      </form>
    </div>
  );
}
